import React,{useState,useEffect} from 'react';
import s from './Clientes.module.css';
import {Btn} from '../UI/Btn';
import {Modal} from '../UI/Modal';
import {Field,Inp} from '../UI/Inp';
import {Avatar} from '../UI/Avatar';
import {Icons} from '../Sidebar/Icons';
import {useStore} from '../../hooks/useStore';
import {store} from '../../utils/store';
import {supabase} from '../../utils/supabase';
import {fmtDate,fmtPhone,openWA} from '../../utils/helpers';

// Input de senha com olho
function SenhaInp({value,onChange,placeholder='••••••'}){
  const [show,setShow]=useState(false);
  return(
    <div style={{position:'relative'}}>
      <Inp type={show?'text':'password'} value={value} onChange={onChange} placeholder={placeholder} style={{paddingRight:40}}/>
      <button type="button" onClick={()=>setShow(v=>!v)} tabIndex={-1}
        style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'var(--g400)',display:'flex',alignItems:'center',padding:4}}>
        {show
          ?<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
          :<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
        }
      </button>
    </div>
  );
}

function CliModal({initial,onClose}){
  const isEdit=!!initial?.id;
  const [nome,setNome]=useState(initial?.nome||'');
  const [email,setEmail]=useState(initial?.email||'');
  const [wa,setWa]=useState(initial?.wa||'');
  const [senha,setSenha]=useState('');
  const [conf,setConf]=useState('');
  const [err,setErr]=useState('');
  const [loading,setLoading]=useState(false);

  const handleSave=async()=>{
    setErr('');
    if(!nome.trim()){setErr('Informe o nome.');return;}
    if(!isEdit){
      if(!email.trim()){setErr('Informe o e-mail para o cliente acessar o portal.');return;}
      if(!senha){setErr('Informe uma senha para o cliente.');return;}
      if(senha.length<6){setErr('Senha mínima 6 caracteres.');return;}
      if(senha!==conf){setErr('Senhas não conferem.');return;}
    }
    setLoading(true);
    try{
      if(isEdit){
        await store.updateCliente(initial.id,{nome:nome.trim(),email,wa});
      } else {
        await store.addCliente({nome:nome.trim(),email:email.trim(),wa,senha});
      }
      onClose();
    }catch(e){setErr(e.message);}
    finally{setLoading(false);}
  };

  return(
    <Modal title={isEdit?'Editar Cliente':'Novo Cliente'} onClose={onClose}
      footer={<><Btn variant="secondary" onClick={onClose}>Cancelar</Btn><Btn onClick={handleSave} disabled={loading}>{loading?'Salvando...':isEdit?'Salvar':'Cadastrar'}</Btn></>}
      maxWidth={440}>
      {err&&<div style={{background:'var(--red-l)',color:'var(--red)',border:'0.5px solid #fca5a5',borderRadius:8,padding:'10px 14px',fontSize:13,marginBottom:14}}>⚠️ {err}</div>}
      <Field label="Nome completo" required><Inp value={nome} onChange={e=>setNome(e.target.value)} placeholder="Maria Silva"/></Field>
      <Field label={isEdit?"E-mail":"E-mail (acesso ao portal)"} required={!isEdit}>
        <Inp type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="maria@email.com" disabled={isEdit}
          style={isEdit?{background:'var(--g50)',color:'var(--g400)'}:{}}/>
        {isEdit&&<p style={{fontSize:11,color:'var(--g400)',marginTop:4}}>O e-mail não pode ser alterado.</p>}
      </Field>
      <Field label="Celular / WhatsApp"><Inp value={wa} onChange={e=>setWa(fmtPhone(e.target.value))} placeholder="(11) 99999-9999" maxLength={16}/></Field>
      {!isEdit&&<>
        <div style={{height:1,background:'var(--g100)',margin:'4px 0 16px'}}/>
        <p style={{fontSize:12,color:'var(--g500)',marginBottom:12}}>🔐 Senha de acesso ao portal de agendamento</p>
        <Field label="Senha" required hint="mín. 6 caracteres"><SenhaInp value={senha} onChange={e=>setSenha(e.target.value)}/></Field>
        <Field label="Confirmar Senha" required><SenhaInp value={conf} onChange={e=>setConf(e.target.value)}/></Field>
      </>}
    </Modal>
  );
}

function ResetModal({pedido, onClose}){
  const [novaSenha,setNovaSenha]=useState('');
  const [conf,setConf]=useState('');
  const [err,setErr]=useState('');
  const [ok,setOk]=useState(false);
  const [loading,setLoading]=useState(false);
  const {tenant}=useStore();

  const handleReset=async()=>{
    setErr('');
    if(novaSenha.length<6){setErr('Senha mínima 6 caracteres.');return;}
    if(novaSenha!==conf){setErr('Senhas não conferem.');return;}
    setLoading(true);
    try{
      // Redefine a senha no banco
      const {data,error}=await supabase.rpc('redefinir_senha_cliente',{
        p_id_admin:tenant.id,
        p_email:pedido.cliente_email,
        p_nova_senha:novaSenha,
      });
      if(error)throw error;
      if(data?.error){setErr(data.error);return;}

      // Marca o pedido como resolvido
      await supabase.from('reset_senha_clientes')
        .update({status:'resolvido'})
        .eq('id',pedido.id);

      setOk(true);
      setTimeout(()=>onClose(true),1500);
    }catch(e){setErr(e.message);}
    finally{setLoading(false);}
  };

  return(
    <Modal title="Redefinir senha do cliente" onClose={()=>onClose(false)}
      footer={!ok&&<><Btn variant="secondary" onClick={()=>onClose(false)}>Cancelar</Btn><Btn onClick={handleReset} disabled={loading}>{loading?'Salvando...':'Redefinir senha'}</Btn></>}
      maxWidth={420}>
      {ok
        ?<div style={{background:'var(--green-l)',color:'var(--green)',border:'0.5px solid #86efac',borderRadius:8,padding:'12px 14px',fontSize:13}}>✅ Senha redefinida com sucesso!</div>
        :<>
          <p style={{fontSize:13,color:'var(--g600)',marginBottom:16}}>
            Definindo nova senha para <strong>{pedido.cliente_nome||pedido.cliente_email}</strong> ({pedido.cliente_email})
          </p>
          {err&&<div style={{background:'var(--red-l)',color:'var(--red)',border:'0.5px solid #fca5a5',borderRadius:8,padding:'10px 14px',fontSize:13,marginBottom:14}}>⚠️ {err}</div>}
          <Field label="Nova Senha" required hint="mín. 6 caracteres">
            <Inp type="password" value={novaSenha} onChange={e=>setNovaSenha(e.target.value)} placeholder="••••••"/>
          </Field>
          <Field label="Confirmar Nova Senha" required>
            <Inp type="password" value={conf} onChange={e=>setConf(e.target.value)} placeholder="••••••"/>
          </Field>
          <p style={{fontSize:12,color:'var(--g400)',marginTop:8}}>
            Após redefinir, comunique a nova senha ao cliente pelo WhatsApp ou e-mail.
          </p>
        </>
      }
    </Modal>
  );
}

export function Clientes(){
  const {clientes}=useStore();
  const {tenant}=useStore();
  const [q,setQ]=useState('');
  const [modal,setModal]=useState(null);
  const [resetModal,setResetModal]=useState(null);
  const [pedidos,setPedidos]=useState([]);
  const [tabAtiva,setTabAtiva]=useState('lista');

  // Carrega pedidos de redefinição pendentes
  useEffect(()=>{
    if(!tenant?.id)return;
    supabase.from('reset_senha_clientes')
      .select('*')
      .eq('id_admin',tenant.id)
      .eq('status','pendente')
      .order('solicitado_em',{ascending:false})
      .then(({data})=>setPedidos(data||[]));
  },[tenant?.id]);

  const list=clientes.filter(c=>c.nome?.toLowerCase().includes(q.toLowerCase())||c.email?.includes(q)||c.wa?.includes(q));
  const del=async id=>{if(window.confirm('Excluir?'))await store.deleteCliente(id);};

  const handleResetClose=(resolvido)=>{
    setResetModal(null);
    if(resolvido){
      setPedidos(p=>p.filter(x=>x.id!==resetModal?.id));
    }
  };

  return(
    <div className={s.wrap}>
      <div className={s.bar}>
        <div className={s.srch}><Icons.Search/><input placeholder="Buscar cliente..." value={q} onChange={e=>setQ(e.target.value)}/></div>
        <div className={s.rgt}>
          <span className={s.cnt}>{clientes.length} clientes</span>
          {pedidos.length>0&&(
            <button
              className={`${s.alertBtn} ${tabAtiva==='pedidos'?s.alertOn:''}`}
              onClick={()=>setTabAtiva(tabAtiva==='pedidos'?'lista':'pedidos')}
            >
              🔑 {pedidos.length} pedido{pedidos.length>1?'s':''} de senha
            </button>
          )}
          <Btn icon={<Icons.Plus/>} onClick={()=>setModal({})}>Novo Cliente</Btn>
        </div>
      </div>

      {/* Pedidos de redefinição de senha */}
      {tabAtiva==='pedidos'&&pedidos.length>0&&(
        <div className={s.pedidosCard}>
          <div className={s.pedidosTitle}>🔑 Pedidos de redefinição de senha</div>
          <div className={s.pedidosList}>
            {pedidos.map(p=>(
              <div key={p.id} className={s.pedidoRow}>
                <div>
                  <div className={s.pedidoNome}>{p.cliente_nome||p.cliente_email}</div>
                  <div className={s.pedidoEmail}>{p.cliente_email} • {new Date(p.solicitado_em).toLocaleDateString('pt-BR')} às {new Date(p.solicitado_em).toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'})}</div>
                </div>
                <Btn size="sm" onClick={()=>setResetModal(p)}>Redefinir senha</Btn>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Lista de clientes */}
      <div className={s.card}><div className={s.tw}>
        <table className={s.tb}>
          <thead><tr><th>Cliente</th><th>E-mail</th><th>WhatsApp</th><th>Cadastro</th><th>Ações</th></tr></thead>
          <tbody>
            {list.length===0&&<tr><td colSpan={5}><div className={s.emp}><Icons.Users/><p>{q?'Nenhum encontrado.':'Nenhum cliente cadastrado.'}</p>{!q&&<Btn size="sm" onClick={()=>setModal({})}>Cadastrar primeiro</Btn>}</div></td></tr>}
            {list.map((c,i)=>(
              <tr key={c.id}>
                <td><div className={s.cf}><Avatar name={c.nome} idx={i} size={34}/><span className={s.cn}>{c.nome}</span></div></td>
                <td>{c.email||<span className={s.dash}>—</span>}</td>
                <td>{c.wa?<button className={s.wa} onClick={()=>openWA(c.wa)}><Icons.WA/>{c.wa}</button>:<span className={s.dash}>—</span>}</td>
                <td style={{fontSize:12,color:'var(--g400)'}}>{fmtDate(c.criadoEm)||'—'}</td>
                <td><div className={s.acts}><button className={s.ab} onClick={()=>setModal(c)}><Icons.Edit/></button><button className={`${s.ab} ${s.abd}`} onClick={()=>del(c.id)}><Icons.Trash/></button></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div></div>

      {modal!==null&&<CliModal initial={modal?.id?modal:null} onClose={()=>setModal(null)}/>}
      {resetModal&&<ResetModal pedido={resetModal} onClose={handleResetClose}/>}
    </div>
  );
}
